module.exports = __webpack_public_path__ + "img/descyuan.521e1a47.jpg";